export function useUrlLocale(): string {
  const url = new URL(window.location.href);
  const foundLocale = url.pathname.split("/")[1];
  const allowedLocales = ["sk", "en", "de"];

  return allowedLocales.includes(foundLocale) ? foundLocale : "sk";
}
